const state = {
    workerList: [],
    workerSelectedHub: null,
    worker: null,
    fulfillmentTable: {},
    testValue: 1,
};
export default state;
